<template>
  <div class="medical-sim-page">
    <!-- 单列：上表单、下表格 -->
    <el-row :gutter="0" class="medical-sim-page__row">
      <el-col :span="24" class="medical-sim-page__col">
        <div class="grid-content bg-purple medical-sim-page__col-inner">
          <el-card class="box-card medical-sim-card medical-sim-card--input" shadow="hover">
            <div slot="header" class="medical-sim-card__header clearfix">
              <i class="el-icon-card-header"></i>
              <span class="medical-sim-card__title">输入症状描述</span>
            </div>
            <div class="medical-sim-card__body-inner medical-sim-input-panel">
              <el-form
                ref="form"
                class="medical-sim-form medical-sim-form--column-fill"
                :model="textForm"
                label-position="top"
                size="mini"
              >
                <el-form-item label="主要症状" class="medical-sim-form__item--flex-grow">
                  <el-input
                    class="medical-sim-textarea medical-sim-textarea--fill"
                    type="textarea"
                    :rows="1"
                    placeholder="请描述主要症状，填写后点击「分析」查询相似病例…"
                    v-model="textForm.chief_complaint"
                  />
                </el-form-item>
                <el-form-item label="出生日期" class="medical-sim-form__item--compact">
                  <el-date-picker
                    v-model="textForm.birth_year"
                    class="medical-sim-date"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                  />
                </el-form-item>
                <el-form-item label="性别" class="medical-sim-form__item--compact medical-sim-form__item--radio">
                  <el-radio-group v-model="textForm.gender" class="medical-sim-radio-group">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item class="medical-sim-form__actions">
                  <el-button
                    type="primary"
                    class="medical-sim-btn-analyze"
                    :loading="analyzing"
                    @click="onSubmit"
                  >
                    分析
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="0" class="medical-sim-page__row medical-sim-page__row--after-form">
      <el-col :span="24" class="medical-sim-page__col">
        <div class="grid-content bg-purple medical-sim-page__col-inner">
          <el-card class="box-card medical-sim-card medical-sim-card--result" shadow="hover">
            <div slot="header" class="medical-sim-card__header medical-sim-card__header--accent clearfix">
              <i class="el-icon-card-header-red"></i>
              <span class="medical-sim-card__title">相似病例</span>
            </div>
            <div class="medical-sim-card__body-inner medical-sim-table-panel">
              <el-table
                class="medical-sim-table"
                :data="sim_results"
                :height="simTableHeight"
                :header-cell-style="{ background: '#363944', color: 'white', border: 'none' }"
                :row-class-name="tableRowClassName"
              >
                <el-table-column sortable prop="patient_id" label="病人ID" min-width="88" />
                <el-table-column
                  sortable
                  prop="patient_gender"
                  label="性别"
                  min-width="72"
                  :formatter="formatter_gender"
                />
                <el-table-column sortable prop="patient_birthday" label="出生年月" min-width="112" />
                <el-table-column sortable min-width="320" prop="chief_complaint" label="主症" show-overflow-tooltip />
                <el-table-column sortable prop="diagnosis" label="症状" min-width="100" show-overflow-tooltip />
                <el-table-column sortable prop="sim" label="相似度" min-width="88" />
                <el-table-column label="操作" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      class="medical-sim-link-btn"
                      @click="open_detail(scope.row)"
                    >
                      详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/assets/css/main.css';
import { buildAppWebUrl } from '@/utils/appWebUrl';

export default {
  name: "MedicalSimService",
  data() {
    return {
      /** 点击「分析」后请求进行中，用于按钮 loading */
      analyzing: false,
      textForm: {
        chief_complaint: '舌红苔黄，嘴里异味，胃口正常，营养吸收不好',
        diagnosis: '身上有汗，大便稀软，呈黑色，鼻子堵塞',
        birth_year: '2018-05-09',
        gender: '1',
      },
      /** 相似病例表格数据，仅点击「分析」并成功返回后赋值 */
      sim_results: [],
      /** 表格可视高度（px），随窗口变化更新，避免固定 466 在不同屏幕上突兀 */
      simTableHeight: 466,
    };
  },
  mounted() {
    this.updateSimTableHeight()
    window.addEventListener('resize', this.updateSimTableHeight, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSimTableHeight)
  },
  methods: {
    /**
     * 根据视口计算表格高度，单列布局下表格占更大纵向空间
     * 无入参
     */
    updateSimTableHeight() {
      const h = typeof window !== 'undefined' ? window.innerHeight : 800
      this.simTableHeight = Math.round(Math.min(Math.max(h * 0.48, 380), 680))
    },
    /**
     * 在新标签页打开病人详情
     * @param {object} row 表格行数据，需含 patient_id
     */
    open_detail(row) {
      window.open(buildAppWebUrl(`/patient/basic?patient_id=${row.patient_id}`), '_blank', 'noopener,noreferrer');
    },
    /**
     * 表格「性别」列展示格式化
     * @param {object} row 当前行
     */
    formatter_gender(row) {
      return row.patient_gender === 1 ? "男" : "女";
    },
    /**
     * 提交表单，请求相似病例接口并更新表格数据
     * 无入参，使用 this.textForm 作为请求体；仅用户点击「分析」时调用，不在进入页面时自动请求
     */
    onSubmit() {
      this.analyzing = true
      this.$http.post(process.env.VUE_APP_API_HOST + "/sym_sim", this.textForm, {"content-type": "application/json"}).then((res) => {
        const list = res.data && res.data.data
        this.sim_results = Array.isArray(list) ? list : []
      }).catch(() => {
        this.$message.error('请求失败，请稍后重试')
      }).finally(() => {
        this.analyzing = false
      })
    },
    /**
     * 表格斑马纹行 class
     * @param {{ rowIndex: number }} param0 行索引
     */
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
  }
}
</script>

<style scoped>
.medical-sim-page {
  max-width: none;
  width: 100%;
  margin: 0 auto;
  padding: 16px 10px 24px;
  box-sizing: border-box;
}

.medical-sim-page__row--after-form {
  margin-top: 18px;
}

.medical-sim-page__col {
  display: flex;
  padding: 0;
}

.medical-sim-page__col-inner {
  flex: 1;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.medical-sim-card /deep/ .el-card__header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  height: auto;
  min-height: 44px;
  padding: 10px 14px;
  background: linear-gradient(180deg, rgba(62, 66, 78, 0.95) 0%, rgba(54, 57, 68, 0.92) 100%);
}

.medical-sim-card--result /deep/ .el-card__header {
  border-bottom-color: rgba(238, 102, 102, 0.2);
}

.medical-sim-card /deep/ .el-card__body {
  background-color: #363944;
  padding: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.medical-sim-card {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.medical-sim-card__header {
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.medical-sim-card__title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.92);
}

.medical-sim-card--input /deep/ .el-card__header {
  min-height: 40px;
  padding: 8px 12px;
}

.medical-sim-card--input .medical-sim-card__body-inner {
  padding: 10px 12px 12px;
}

.medical-sim-card__body-inner {
  padding: 14px 14px 16px;
  flex: 1;
  min-height: 0;
}

/* 表单区：压缩占用高度，把更多纵向空间留给下方表格 */
.medical-sim-input-panel {
  display: flex;
  flex-direction: column;
  min-height: min(22vh, 220px);
}

.medical-sim-form--column-fill {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.medical-sim-form /deep/ .el-form-item__label {
  color: rgba(255, 255, 255, 0.72);
  padding-right: 0;
  padding-bottom: 4px;
  line-height: 1.25;
  width: 100% !important;
}

.medical-sim-form__item--flex-grow {
  flex: 1 1 auto;
  min-height: 0;
  margin-bottom: 8px !important;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.medical-sim-form__item--flex-grow /deep/ .el-form-item__content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.medical-sim-form__item--compact {
  margin-bottom: 8px !important;
}

.medical-sim-form__item--radio /deep/ .el-form-item__content {
  line-height: 28px;
}

.medical-sim-textarea--fill {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.medical-sim-textarea--fill /deep/ .el-textarea {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.medical-sim-textarea--fill /deep/ .el-textarea__inner {
  height: 100% !important;
  min-height: 96px;
  resize: vertical;
  box-sizing: border-box;
  font-size: 13px;
  line-height: 1.55;
  border-radius: 8px;
  background: #2d313a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.medical-sim-textarea--fill /deep/ .el-textarea__inner:focus {
  border-color: rgba(46, 205, 129, 0.55);
  box-shadow: 0 0 0 1px rgba(46, 205, 129, 0.25);
}

.medical-sim-textarea--fill /deep/ .el-textarea__inner::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.medical-sim-date {
  width: 100%;
}

.medical-sim-date /deep/ .el-input__inner {
  border-radius: 8px;
  background: #2d313a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}

.medical-sim-date /deep/ .el-input__inner:focus {
  border-color: rgba(46, 205, 129, 0.55);
}

.medical-sim-radio-group /deep/ .el-radio {
  margin-right: 20px;
  color: rgba(255, 255, 255, 0.82);
}

.medical-sim-radio-group /deep/ .el-radio__inner {
  background: #2d313a;
  border-color: rgba(255, 255, 255, 0.25);
}

.medical-sim-radio-group /deep/ .el-radio__input.is-checked .el-radio__inner {
  background: rgb(46, 205, 129);
  border-color: rgb(46, 205, 129);
}

.medical-sim-form__actions {
  margin-bottom: 0;
  flex-shrink: 0;
  margin-top: auto;
  padding-top: 8px;
}

.medical-sim-form__actions /deep/ .el-form-item__content {
  display: flex;
  justify-content: flex-end;
}

.medical-sim-btn-analyze {
  min-width: 96px;
  padding: 8px 18px;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.04em;
  background-color: rgb(46, 205, 129) !important;
  border-color: rgb(46, 205, 129) !important;
  color: #fff !important;
  box-shadow: 0 4px 14px rgba(46, 205, 129, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}

.medical-sim-btn-analyze:hover,
.medical-sim-btn-analyze:focus {
  filter: brightness(1.06);
  box-shadow: 0 6px 18px rgba(46, 205, 129, 0.45);
}

.medical-sim-btn-analyze:active {
  transform: translateY(1px);
}

.medical-sim-table-panel {
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.medical-sim-table /deep/ .el-table {
  background-color: #363944;
  color: white;
}

/* 表体区域：与其它页一致，覆盖 Element 默认 td 白底（尤其是固定列/滚动区域） */
.medical-sim-table /deep/ .el-table__body-wrapper,
.medical-sim-table /deep/ .el-table__footer-wrapper {
  background-color: #363944;
}

.medical-sim-table /deep/ .el-table__empty-block {
  background-color: #363944;
}

.medical-sim-table /deep/ .el-table__empty-text {
  color: rgba(255, 255, 255, 0.55);
}

.medical-sim-table /deep/ .el-table__fixed-right::before,
.medical-sim-table /deep/ .el-table__fixed::before {
  box-shadow: none;
}

.medical-sim-table /deep/ .el-table__fixed-right-patch {
  background-color: #363944 !important;
}

.medical-sim-table /deep/ .el-table__header-wrapper {
  background-color: #363944;
}

.medical-sim-table /deep/ .el-table::before,
.medical-sim-table /deep/ .el-table::after {
  display: none;
}

.medical-sim-table /deep/ .el-table th {
  font-weight: 600;
}

.medical-sim-table /deep/ .el-table td,
.medical-sim-table /deep/ .el-table th {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.medical-sim-table /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.medical-sim-table /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 4px;
}

.medical-sim-link-btn {
  color: #5ceaa8 !important;
  font-weight: 600;
}

.medical-sim-link-btn:hover {
  color: #7ff0c0 !important;
}

.medical-sim-table /deep/ tbody tr:hover > td {
  background-color: #4e5260 !important;
}

.medical-sim-table /deep/ tbody tr:hover {
  color: black !important;
}

.medical-sim-table /deep/ .warning-row1 {
  background: #363944;
}

.medical-sim-table /deep/ .warning-row1 > td {
  background-color: #363944 !important;
  border: none;
}

.medical-sim-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.medical-sim-table /deep/ .success-row1 > td {
  background-color: #3C3F4A !important;
  border: none;
}
</style>
